/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/recipes'>.
 * exact; render.ready[1][2]/[0][2]
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import Recipes from '@routes/Recipes';

export const Route = createFileRoute('/recipes/')({
  component: () => <CacheDataRoute component={Recipes} path='/recipes' />
});
